
export enum Role{

    Admin = 2,
    TechSupport = 3,
    Ceo = 4,
    
    // FinanaceManager = 6,
    // BRMR001 = 11
}